// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__jS9MH","warning":"styles_warning__npCdX"};